import { inject, Injectable } from '@angular/core';
import { RaxBFF } from '@raxapi/booker.planner.bff.api';
import { NextObserver, Observable, Subject } from 'rxjs';
import { LocationLiveUpdateSignalRService } from './location-live-update-signalR.service';

@Injectable({
    providedIn: 'root',
})
export class LocationLiveUpdateService {
    private signalRService = inject(LocationLiveUpdateSignalRService);
    public isConnected = this.signalRService.isConnected;

    private _refreshLocationRelatedObjectNameData = new Subject<void>();
    public readonly refreshLocationRelatedObjectNameData$: Observable<void> = this._refreshLocationRelatedObjectNameData.asObservable();
    private _refreshLocationCoreData = new Subject<void>();
    public readonly refreshLocationCoreData$: Observable<void> = this._refreshLocationCoreData.asObservable();

    constructor() {
        this.signalRService.messages$.subscribe(this.onMessage);
    }

    private onMessage: NextObserver<RaxBFF.LocationLiveUpdateMessage> = {
        next: (message) => {
            console.log('Live updates message recieved: ', message);
        },
    };
}
